import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SurveyAnswer = AnyJson;
export interface SurveyAnswersState {
  [key: string]: SurveyAnswer;
}

const surveyAnswersSlice = createSlice({
  name: "surveyAnswers",
  initialState: {} as SurveyAnswersState,
  reducers: {
    addSurveyAnswers(state, action: PayloadAction<SurveyAnswersState>) {
      return { ...state, ...action.payload };
    },
    setSurveyAnswers(state, action: PayloadAction<SurveyAnswersState>) {
      return { ...action.payload };
    },
  },
});

export const { addSurveyAnswers, setSurveyAnswers } =
  surveyAnswersSlice.actions;

export default surveyAnswersSlice;
